import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { Box, Typography } from '@mui/material';
import { useEffect, useMemo } from 'react';
import useSWR from 'swr';
import _ from 'lodash';
import { v4 } from 'uuid';
import { queryParams } from '@shared/commonFunctions';
import { SERVICES } from '@shared/constants/apiConfig';
import { ContactAlertButton } from '@styles/ContactManager/ContactStyles';

import { NContact } from './validation';
import { EAlertMessage, EGreenAlertMessages, IAlertMessages } from './interfaces';
import { ContactAlertPopOver } from './ContactAlertPopOver';

const individualNotificationKeys=['DNC','NC'];

export const ContactAlerts = ({ count }: { count: number }) => {
  const params = queryParams();
  const url = useMemo(() => {
    let url = `/${SERVICES.APICOMPOSER}/v1/contacts/${params.id}/notifications`;
    if (params.assetId) {
      url = `${url}?assetId=${params.assetId}`;
    }
    return url;
  }, [params.id, params.assetId]);
  const { data, mutate } = useSWR<NContact.Entity>(params.id && url, { revalidateOnMount: false });

  useEffect(() => {
    if (count) {
      mutate();
    }
  }, [count]);

  const formattedAlertMessages = useMemo(() => {
    const accValue: IAlertMessages = {
      individual: [],
      red: [],
      orange: [],
    };   

    let result;
    if ((data?.notifications || []).length > 4) {
      result = (data?.notifications || []).reduce((acc, cur) => {
          if (cur.color === EAlertMessage.Green) {
            acc.individual.push(cur);
          } else if (cur.color === EAlertMessage.Red) {
            if (individualNotificationKeys.includes(cur.key)) {
              acc.individual.push(cur);
            } else {
              acc.red.push(cur);
            }
          } else {
            acc.orange.push(cur);
          }
          return acc;
        }, accValue);
    }
    else
    {
      result = (data?.notifications || []).reduce((acc, cur) => {
        acc.individual.push(cur);
        return acc;
      }, accValue);
    }

    const sortedAlertMessages = _.sortBy(
      result.individual,
      (notification) => EGreenAlertMessages[notification.message as keyof typeof EGreenAlertMessages]
    );
    result.individual = sortedAlertMessages;
    return result;
  }, [data]);

  if (!data?.notifications) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', my: '7px' }}>
      {(formattedAlertMessages.individual || []).map((individualAlertMessage) => (
        <ContactAlertButton
          key={`${individualAlertMessage?.key}-${v4()}`}
          $messageColor={individualAlertMessage?.color}
          variant="contained"
        >
          {individualAlertMessage?.color === EAlertMessage.Green ? <CheckOutlinedIcon /> : <ErrorOutlineOutlinedIcon />}
          <Typography
            noWrap
            variant="subtitle1"
            display="block"
            marginLeft="10px"
            overflow="hidden"
            textOverflow="ellipsis"
            fontWeight="bold"
          >
            {`${individualAlertMessage?.key}${individualAlertMessage?.message ? `: ${individualAlertMessage.message}` : ''}`}
          </Typography>
        </ContactAlertButton>
      ))}
      {formattedAlertMessages.red.length > 0 && <ContactAlertPopOver alertMessages={formattedAlertMessages.red} />}
      {formattedAlertMessages.orange.length > 0 && <ContactAlertPopOver alertMessages={formattedAlertMessages.orange} />}
    </Box>
  );
};
